import { render, staticRenderFns } from "./shudiLeftTwo.vue?vue&type=template&id=cfdb255c&scoped=true"
import script from "./shudiLeftTwo.vue?vue&type=script&lang=js"
export * from "./shudiLeftTwo.vue?vue&type=script&lang=js"
import style0 from "./shudiLeftTwo.vue?vue&type=style&index=0&id=cfdb255c&prod&lang=scss&scoped=true"
import style1 from "./shudiLeftTwo.vue?vue&type=style&index=1&id=cfdb255c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdb255c",
  null
  
)

export default component.exports